
/**
 * URL utilities for property slugs and navigation
 */

export const titleToSlug = (title: string): string => {
  return title
    .toLowerCase()
    .replace(/[áàäâ]/g, 'a')
    .replace(/[éèëê]/g, 'e')
    .replace(/[íìïî]/g, 'i')
    .replace(/[óòöô]/g, 'o')
    .replace(/[úùüû]/g, 'u')
    .replace(/ñ/g, 'n')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .trim();
};

export const buildPropertyUrl = (title: string, params?: URLSearchParams): string => {
  const slug = titleToSlug(title);
  const baseUrl = `/propiedades/${slug}`;
  return params && params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;
};

export const copyUrlToClipboard = async (url?: string): Promise<boolean> => {
  try {
    const targetUrl = url || window.location.href;
    await navigator.clipboard.writeText(targetUrl);
    return true;
  } catch (error) {
    console.error('Error copying URL to clipboard:', error);
    return false;
  }
};
